import ArticleCardLarge from './ArticleCardLarge'

export default ArticleCardLarge
